export const GET_TEMPLATES = "/admin_requests/templates";
export const ADD_TEMPLATE = GET_TEMPLATES;
export const EDIT_TEMPLATE = GET_TEMPLATES;
export const GET_TEMPLATE_CATEGORIES = `${GET_TEMPLATES}/categories/`;
export const DELETE_TEMPLATE = `${GET_TEMPLATES}`;
